import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import IntroAnimation from "@/components/site/IntroAnimation";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <IntroAnimation />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors duration={2000} />
      </CartProvider>
    </div>
  );
}

export default App;
